import { useEffect } from "react"

function useKeyboard(callback: () => void, keyCodes: string[]): void {
  const handler = ({ code }: KeyboardEvent) => {
    if (keyCodes.includes(code)) {
      callback()
    }
  }

  useEffect(() => {
    window.addEventListener("keydown", handler)
    return () => {
      window.removeEventListener("keydown", handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
export default useKeyboard
